import React, { Fragment, useEffect, useState } from 'react'
import { Avatar, Box, Grid, IconButton, TextField, Typography } from '@mui/material';
import { Search } from '@mui/icons-material';
import Colors from '../../Assets/Styles/Colors';
import { useNavigate, useLocation } from 'react-router-dom';
import { KeyboardArrowLeft } from '@mui/icons-material';
import BreadCrumbs from '../../Components/BreadCrumbs/BreadCrumbs';
import ChatServices from '../../Api/Chats/ChatServices';
import { baseUrl } from '../../../axios';
import moment from 'moment';

function Conversations() {
  const [chats, setChats] = useState([]);
  console.log("🚀 ~ Conversations ~ chats:", chats)
  const [chatId, setChatId] = useState("");
  const [messages, setMessages] = useState([]);
  const [receivedBy, setReceivedBy] = useState("");
  const [sentBy, setSentBy] = useState("");
  const [text, setText] = useState("");
  console.log("🚀 ~ Conversations ~ text:", text)
  const { state } = useLocation();

  console.log("🚀 ~ Conversations ~ state:", state)
  const getChats = async (text) => {
    try {
      const result = await ChatServices.getAllChats(state?.adId, state?.userId, text ? text : "");
      if (result.responseCode == 200) {
        setChats(result?.data?.result);
      }
    } catch (err) {
      console.log(err);
    };
  };

  const getMessages = async (chatId) => {
    try {
      const result = await ChatServices.getAllMessages(state?.adId, state?.userId, chatId);
      if (result.responseCode == 200) {
        console.log(result);
        const sortMessages = result?.data?.messages?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        console.log("🚀 ~ getMessages ~ sortMessages:", sortMessages)
        setMessages(sortMessages);
        setReceivedBy(result?.data?.messages[0].receivedBy[0]?.userId);
        setSentBy(result?.data?.messages[0]?.sentBy)
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (state) {
      getChats();
    }
  }, []);


  useEffect(() => {
    const chat = setTimeout(() => {
      getChats(text);
    }, 1000);
    return () => clearTimeout(chat);
  }, [text])

  const navigate = useNavigate();
  return (
    <Box>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          background: Colors.primaryGradient,
          p: 2,
          borderRadius: "12px",
        }}
      >
        <Grid item xs={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <IconButton onClick={() => navigate(-1)}>
              <KeyboardArrowLeft sx={{ color: Colors.white }} />
            </IconButton>
            <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
              Conversations
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <BreadCrumbs currentPage={["Conversations"]} />
        </Grid>
      </Grid>
      <Box>
        <Grid container>
          <Fragment>
            <Grid item md={4}>
              <Box
                sx={{ borderRight: "1px solid #dddddd", height: "100%" }}
              >
                <Grid container sx={{ position: "sticky", top: "10%" }}>
                  <Grid item md={12}>
                    <Box sx={{ p: 2 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: "20px" }}>
                        Chats
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item md={12}>
                    <Box sx={{ p: "0px 16px 16px 16px" }}>
                      <TextField
                        variant='filled'
                        placeholder='Search'
                        fullWidth
                        InputProps={{
                          disableUnderline: true,
                          startAdornment: <Search sx={{ color: "#7d7d7d", fontSize: "20px" }} />
                        }}
                        sx={{
                          "input": {
                            p: "10px 20px",
                            fontSize: "14px"
                          },
                          ".MuiInputBase-root": {
                            borderRadius: "8px",
                            pl: "20px"
                          },
                        }}
                        onChange={(e) => setText(e.target.value)}
                      />
                    </Box>
                  </Grid>
                  {chats?.map((item, i) => (
                    <Grid key={i} item md={12}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          pl: 2,
                          transition: "all .3s ease-in-out",
                          backgroundColor: chatId == item._id ? "#f1f1f1" : "transparent",
                          ":hover": {
                            backgroundColor: "#f1f1f1",
                            cursor: "pointer"
                          }
                        }}
                      >
                        <Avatar
                          alt="image"
                          src={baseUrl + item?.participants[1]?.image}
                          sx={{ width: 56, height: 56 }}
                        />
                        <Box
                          sx={{
                            p: 2,
                            width: "100%",
                            borderBottom: "1px solid #dddddd",
                          }}
                          onClick={() => {
                            getMessages(item._id);
                            setChatId(item._id)
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: "16px",
                              width: "100%"
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <Typography sx={{ fontWeight: 600 }}>
                                {item.lastMessage.Name}
                              </Typography>
                              <Typography sx={{ fontSize: "14px", color: "#a1a1a1" }}>
                                {item.lastMessage.body}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography sx={{ fontSize: "12px", color: "#8e8e8e" }}>
                                {moment(item.lastMessage?.createdAt).format("HH:mm")}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
            <Grid item md={8}>
              <Box sx={{ p: 2 }}>
                <Grid container>
                  {messages.map((item, i) => (
                    <Grid key={i} item md={12}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: item.sentBy == sentBy ? "row" : "row-reverse",
                          justifyContent: "flex-start",
                          gap: "12px",
                          p: 1,
                        }}
                      >
                        <Avatar alt="img" src={baseUrl + item.image} />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            flexDirection: "column",
                            borderRadius: item.sentBy === sentBy ? "0px 8px 8px 8px" : "8px 0px 8px 8px",
                            backgroundColor: "#c7eaff",
                            p: 1,
                            position: "relative",
                            "&::before": {
                              content: '""',
                              position: "absolute",
                              width: 0,
                              height: 0,
                              borderStyle: "solid",
                              borderWidth: item.sentBy === sentBy
                                ? "0px 8px 8px 0"
                                : "0px 8px 8px 8px",
                              borderColor: item.sentBy === sentBy
                                ? "transparent #c7eaff transparent transparent"
                                : "transparent transparent transparent #c7eaff",
                              top: "0px",
                              left: item.sentBy === sentBy ? "-8px" : "auto",
                              right: item.sentBy === sentBy ? "auto" : "-16px",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              textAlign: item.sentBy == sentBy ? "left" : "right",
                              color: "#2b292b",
                              fontSize: "14px",
                            }}
                          >
                            {item.body}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "10px",
                              color: "#8e8e8e",
                              textAlign: item.sentBy == sentBy ? "right" : "left",
                            }}
                          >
                            {moment(item.createdAt).format("HH:mm")}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
          </Fragment>
        </Grid>
      </Box>
    </Box>
  )
}

export default Conversations